<!-- src/App.vue -->
<template>
  <div>
    <!-- 方案2：简化结构（推荐） -->
    <div class="main-wrapper">
      <router-view />
    </div>
  </div>
</template>

<script>
import { ref, watch, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessageBox, ElMessage } from 'element-plus'
import Cookies from 'js-cookie'
import axios from 'axios';
import config from '@/config.js';

export default {
  name: 'App',
  setup() {
    const router = useRouter()
    const isLoggedIn = ref(!!Cookies.get('user_token'))

    // 获取并设置网站图标和标题
    const fetchWebConfig = async () => {
      try {
        const response = await axios.get(`${config.BASE_URL}/shop/api/web_icon.php`)
        if (response.data.success) {
          const { shop_name, h5_favicon } = response.data.data

          // 设置浏览器标题
          document.title = shop_name

          // 设置浏览器图标
          const favicon = document.querySelector("link[rel*='icon']") || document.createElement('link')
          favicon.type = 'image/x-icon'
          favicon.rel = 'shortcut icon'
          favicon.href = h5_favicon
          document.getElementsByTagName('head')[0].appendChild(favicon)
        }
      } catch (error) {
        console.error('获取网站配置失败:', error)
        // 设置默认标题
        document.title = '碰一碰商业版'
      }
    }

    const checkLoginStatus = () => {
      isLoggedIn.value = !!Cookies.get('user_token')
    }

    setInterval(checkLoginStatus, 300)

    watch(
      () => Cookies.get('user_token'),
      (newValue) => {
        isLoggedIn.value = !!newValue
      }
    )

    const handleLogout = async () => {
      try {
        await ElMessageBox.confirm(
          '确定要退出登录吗？所有未保存数据将会丢失！',
          '警告',
          {
            confirmButtonText: '确认退出',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'logout-confirm',
            closeOnClickModal: false
          }
        )

        Cookies.remove('user_token')
        Cookies.remove('user_info')
        isLoggedIn.value = false

        router.push('/login')
        ElMessage.success('您已安全退出系统')
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('退出操作失败，请重试')
        }
      }
    }

    // 在组件挂载时获取配置
    onMounted(() => {
      fetchWebConfig()
    })

    return {
      isLoggedIn,
      handleLogout
    }
  }
}
</script>

<style>
/* 全局背景样式 */
.main-wrapper {
  min-height: 100vh;
  box-sizing: border-box;
  margin: -8px;
  background: linear-gradient(135deg, 
    #0c0e29 0%, 
    #1a1f3d 25%, 
    #252a4a 50%, 
    #1e233f 75%, 
    #141732 100%);
  position: relative;
  overflow-x: hidden;
}

/* 科技感背景效果 */
.main-wrapper::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 80%, rgba(0, 242, 254, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(148, 0, 211, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 40% 40%, rgba(255, 0, 128, 0.05) 0%, transparent 50%);
  pointer-events: none;
  z-index: 0;
}

/* 网格背景 */
.main-wrapper::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    linear-gradient(rgba(0, 242, 254, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 242, 254, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  pointer-events: none;
  z-index: 0;
}

/* 全局按钮样式 */
.el-button {
  border-radius: 8px !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative;
  overflow: hidden;
}

.el-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, 
    transparent, 
    rgba(255, 255, 255, 0.2), 
    transparent);
  transition: left 0.6s ease;
}

.el-button:hover::before {
  left: 100%;
}

/* 主要按钮样式 */
.el-button--primary {
  background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%) !important;
  border: none !important;
  box-shadow: 0 4px 15px rgba(0, 242, 254, 0.3) !important;
}

.el-button--primary:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(0, 242, 254, 0.4) !important;
}

/* 成功按钮样式 */
.el-button--success {
  background: linear-gradient(135deg, #00d4ff 0%, #00ff88 100%) !important;
  border: none !important;
  box-shadow: 0 4px 15px rgba(0, 212, 255, 0.3) !important;
}

.el-button--success:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(0, 212, 255, 0.4) !important;
}

/* 警告按钮样式 */
.el-button--warning {
  background: linear-gradient(135deg, #ff6b9d 0%, #ffa726 100%) !important;
  border: none !important;
  box-shadow: 0 4px 15px rgba(255, 107, 157, 0.3) !important;
}

.el-button--warning:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(255, 107, 157, 0.4) !important;
}

/* 危险按钮样式 */
.el-button--danger {
  background: linear-gradient(135deg, #ff4757 0%, #ff6b81 100%) !important;
  border: none !important;
  box-shadow: 0 4px 15px rgba(255, 71, 87, 0.3) !important;
}

.el-button--danger:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(255, 71, 87, 0.4) !important;
}

/* 信息按钮样式 */
.el-button--info {
  background: linear-gradient(135deg, #a0a8b8 0%, #c0c8d8 100%) !important;
  border: none !important;
  box-shadow: 0 4px 15px rgba(160, 168, 184, 0.3) !important;
}

.el-button--info:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(160, 168, 184, 0.4) !important;
}

/* 全局输入框样式 */
.el-input {
  --el-input-bg-color: rgba(255, 255, 255, 0.08);
  --el-input-border-color: rgba(0, 242, 254, 0.3);
  --el-input-hover-border-color: #00f2fe;
  --el-input-focus-border-color: #00f2fe;
}

.el-input__wrapper {
  background: rgba(255, 255, 255, 0.08) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 242, 254, 0.3) !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1) !important;
}

.el-input__wrapper:hover {
  border-color: #00f2fe !important;
  box-shadow: 0 4px 15px rgba(0, 242, 254, 0.2) !important;
}

.el-input__wrapper.is-focus {
  border-color: #00f2fe !important;
  box-shadow: 0 4px 20px rgba(0, 242, 254, 0.3) !important;
}

.el-input__inner {
  color: #000000 !important;
  background: transparent !important;
  font-weight: 500 !important;
}

.el-input__inner::placeholder {
  color: #b0b8c8 !important;
}

/* 文本域样式 */
.el-textarea__inner {
  background: rgba(255, 255, 255, 0.08) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 242, 254, 0.3) !important;
  border-radius: 8px !important;
  color: #000000 !important;
  transition: all 0.3s ease !important;
}

.el-textarea__inner:hover {
  border-color: #00f2fe !important;
  box-shadow: 0 4px 15px rgba(0, 242, 254, 0.2) !important;
}

.el-textarea__inner:focus {
  border-color: #00f2fe !important;
  box-shadow: 0 4px 20px rgba(0, 242, 254, 0.3) !important;
}

/* 选择器样式 */
.el-select .el-input__wrapper {
  background: rgba(255, 255, 255, 0.08) !important;
  backdrop-filter: blur(10px);
}

/* 下拉菜单样式 */
.el-select-dropdown {
  background: rgba(26, 31, 61, 0.95) !important;
  backdrop-filter: blur(15px);
  border: 1px solid rgba(0, 242, 254, 0.3) !important;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4) !important;
}

.el-select-dropdown__item {
  color: #e0e6ff !important;
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: rgba(0, 242, 254, 0.1) !important;
}

.el-select-dropdown__item.selected {
  color: #00f2fe !important;
  background: rgba(0, 242, 254, 0.08) !important;
}

/* 确保路由内容在背景之上 */
.router-view-content {
  position: relative;
  z-index: 1;
}

.upload-tip {
  font-size: 12px;
  color: #a0a8b8 !important;
  margin-top: 8px;
}

.el-upload__tip {
  margin-top: 0 !important;
}

/* 自定义滚动条 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);
  border-radius: 6px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
}

::-webkit-scrollbar-corner {
  background: transparent;
}
</style>

<style scoped>
.main-wrapper {
  min-height: 100vh;
  box-sizing: border-box;
  margin: -8px;
}

.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}

.el-upload__tip {
  margin-top: 0 !important;
}
</style>